var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.984375 8C1.76771 3.73333 5.50688 0.5 10.0002 0.5C14.4935 0.5 18.2319 3.73333 19.016 8C18.2327 12.2667 14.4935 15.5 10.0002 15.5C5.50688 15.5 1.76854 12.2667 0.984375 8ZM10.0002 12.1667C11.1053 12.1667 12.1651 11.7277 12.9465 10.9463C13.7279 10.1649 14.1669 9.10507 14.1669 8C14.1669 6.89493 13.7279 5.83512 12.9465 5.05372C12.1651 4.27232 11.1053 3.83333 10.0002 3.83333C8.89514 3.83333 7.83533 4.27232 7.05393 5.05372C6.27253 5.83512 5.83354 6.89493 5.83354 8C5.83354 9.10507 6.27253 10.1649 7.05393 10.9463C7.83533 11.7277 8.89514 12.1667 10.0002 12.1667ZM10.0002 10.5C9.33717 10.5 8.70128 10.2366 8.23244 9.76777C7.7636 9.29893 7.50021 8.66304 7.50021 8C7.50021 7.33696 7.7636 6.70107 8.23244 6.23223C8.70128 5.76339 9.33717 5.5 10.0002 5.5C10.6632 5.5 11.2991 5.76339 11.768 6.23223C12.2368 6.70107 12.5002 7.33696 12.5002 8C12.5002 8.66304 12.2368 9.29893 11.768 9.76777C11.2991 10.2366 10.6632 10.5 10.0002 10.5Z",
    fill: "#2262ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeActive);
export default __webpack_public_path__ + "static/media/open_eye_active.c836d5f1d1ba36e68ad698ce55518edd.svg";
export { ForwardRef as ReactComponent };